// Note : Exanple Theme
export default {

    direction: 'ltr',

    palette: {
        primary: {
            main: '#5675D3',
            light: '',
            dark: '#0e5f96',
            contrastText: '#fff',
        },
        secondary: {
            main: '#FF1493',
            light: '',
            dark: '#E82868',
            contrastText: '#000',
        },
        textColor: {
            gray: '#777',
            gray2: '#ddd',
            gray3: '#eee',
            gray4: '#f2f4f4',
            gray5: '#0000008a',
            green: '#19b821',
            blue: '#2757ca',
            blue2: '#32bdea',
            green2: '#1CBA34',
        },
        success:{
            main: '#00ff00',
        },
        info:{
            main: '#30bcec',
        },
        warning:{
            main: '#fdb31b'
        },
        danger:{
            main: '#ff0000',
        }
    },

    typography: {
        useNextVariants: true,
    }
}